var _path, _g, _path2, _path3, _path4, _g2, _path5, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 339,
    height: 343,
    viewBox: "0 0 339 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5607 4.47201L16.5916 11.7595L22.1811 16.5118L14.8445 16.5006L10.0921 22.0255L10.0613 14.7379L4.47176 9.98572L11.8084 9.99692L16.5607 4.47201Z",
    fill: "#EBDD9A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_344_754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5607 4.47201L16.5916 11.7595L22.1811 16.5118L14.8445 16.5006L10.0921 22.0255L10.0613 14.7379L4.47176 9.98572L11.8084 9.99692L16.5607 4.47201Z",
    fill: "#EBDD9A"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4484 329.285L52.1938 334.002L56.9106 335.747L52.1938 337.493L50.4484 342.209L48.7031 337.493L43.9863 335.747L48.7031 334.002L50.4484 329.285Z",
    fill: "#EBDD9A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89928 283.304L9.98367 284.315L10.806 284.909L9.79513 284.993L9.2012 285.816L9.11681 284.805L8.29452 284.211L9.30535 284.126L9.89928 283.304Z",
    fill: "#EBDD9A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M330.652 131.097L330.454 133.47L328.523 134.865L330.897 135.063L332.291 136.994L332.489 134.62L334.42 133.226L332.047 133.028L330.652 131.097Z",
    fill: "#EBDD9A"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_344_754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.652 131.097L330.454 133.47L328.523 134.865L330.897 135.063L332.291 136.994L332.489 134.62L334.42 133.226L332.047 133.028L330.652 131.097Z",
    fill: "#EBDD9A"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M330.423 38.6755L331.489 40.0264L333.208 40.0967L331.858 41.1625L331.787 42.8817L330.721 41.5308L329.002 41.4605L330.353 40.3948L330.423 38.6755Z",
    fill: "#EBDD9A"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_344_754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.423 38.6755L331.489 40.0264L333.208 40.0967L331.858 41.1625L331.787 42.8817L330.721 41.5308L329.002 41.4605L330.353 40.3948L330.423 38.6755Z",
    fill: "#EBDD9A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_344_754",
    x: -0.000464916,
    y: 0.000511646,
    width: 26.6533,
    height: 26.497,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.23607,
    result: "effect1_foregroundBlur_344_754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_344_754",
    x: 324.051,
    y: 126.626,
    width: 14.8408,
    height: 14.8408,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.23607,
    result: "effect1_foregroundBlur_344_754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_344_754",
    x: 324.53,
    y: 34.2036,
    width: 13.1503,
    height: 13.1494,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.23607,
    result: "effect1_foregroundBlur_344_754"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.b5b358c96a55922009f430af0b073573.svg";
export { ForwardRef as ReactComponent };